export type NotificationTarget = 'Wbe' | 'TableReservation' | 'GiftCardShop';

export type NotificationPhase =
  | 'Home' | 'Availability' | 'Profile' | 'Confirmation'
  | 'Cancellation' | 'DatePicker'
  | 'ChooseRestaurant' | 'Guests' | 'Date' | 'Time' | 'Summary'
  | 'GiftCardListing' | 'Checkout' | 'GiftCardDownload';

export interface IPimNotificationText {
  lang: string;
  title: string;
  message: string | null;
}

export interface IPimNotificationRule {
  ruleType: 'CodeRule' | 'SearchMaskRule';
  name: string;     // e.g. RATECODE, ADULTS, CATEGORY
  operator: string; // IS_IN | NOT_IN | LESS_THAN | ... | EQUAL | NOT_EQUAL
  value: string;
}

export interface IPimNotification {
  id: string;
  target: NotificationTarget;
  phases: NotificationPhase[];          // [] = all phases
  validityStartDate: string | null;     // ISO 8601, UTC
  validityEndDate: string | null;
  stayStart: string | null;
  stayEnd: string | null;
  weekdays: number;                      // bitmask, Mon = bit 0
  texts: IPimNotificationText[];
  rules: IPimNotificationRule[];
  color?: string;                        // optional; not in current schema
}

/** Resolved notification ready for display. */
export interface IPimNotificationDisplay {
  id: string;
  title: string;
  message: string | null;
  color?: string;
}

/** Context used to evaluate notification rules / stay dates. */
export interface IPimNotificationContext {
  selectedHotelCode: string | null;
  selectedArrival: Date | string | null;
  selectedDeparture: Date | string | null;
  searchMask: {
    adults: number | null;
    persons: number | null;
    children: number | null;
    childAge: number | null;
    nroOfRooms: number | null;
    category: string | null;
  };
  selectedRateCode: string[];
  selectedRoomCode: string[];
  selectedRateCategory: string[];
  selectedRoomCategory: string[];
  selectedExtraCode: string[];
  selectedAllotmentCode: string[];
  selectedDepartmentCode: string[];
  selectedCampaignCode: string[];
}

/** Empty context — every field absent. Used by apps without searchmask. */
export const EMPTY_PIM_NOTIFICATION_CONTEXT: IPimNotificationContext = {
  selectedHotelCode: null,
  selectedArrival: null,
  selectedDeparture: null,
  searchMask: {
    adults: null, persons: null, children: null,
    childAge: null, nroOfRooms: null, category: null,
  },
  selectedRateCode: [],
  selectedRoomCode: [],
  selectedRateCategory: [],
  selectedRoomCategory: [],
  selectedExtraCode: [],
  selectedAllotmentCode: [],
  selectedDepartmentCode: [],
  selectedCampaignCode: [],
};
